module.exports = __webpack_public_path__ + "img/case2.a6126eec.jpg";